import React, { Component } from 'react';
import isWindow from 'components/common/helpers/isWindow';

export default (ComposedComponent, options = {}) => {

  return class Resizer extends Component {

    constructor() {
      super();
      this.timeoutObj = null;
      if (isWindow) {
        this.state = {
          width: window.innerWidth,
          height: window.innerHeight
        };
      } else {
        this.state = {
          width: options.defaultWidth || 1000,
          height: options.defaultHeight || 1000,
        };
      }
    }

    handleResize() {
      // set initial state
      this.setState({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }

    componentDidMount() {
      // bind window resize listeners
      if (isWindow) {
        this._handleResize = this.handleResize.bind(this);
        window.addEventListener('resize', this._handleResize);
        this.timeoutObj = setTimeout(this._handleResize, 1000);
      }
    }

    componentWillUnmount() {
      // clean up listeners
      if (isWindow) {
        clearTimeout(this.timeoutObj);
        window.removeEventListener('resize', this._handleResize);
      }
    }

    getWrappedInstance() {
      return this.wrappedInstance;
    }

    render() {
      return (
        <ComposedComponent
          {...this.props}
          windowWidth={this.state.width}
          windowHeight={this.state.height}
        />
      );
    }
  }

};
